<div class="profile-button primary-color" [ngClass]="{'uk-background-muted': isHovering }" (mouseover)="isHovering = true" (mouseleave)="isHovering = false">
  <i class="material-icons">
    {{icon}}
  </i>
  <div class="text">
    <h4>{{ title | uppercase }}</h4>
    <h5>{{subtitle}}</h5>
  </div>
</div>
